import { createReducer } from "typesafe-actions";

import {
  resetSavedAddresses,
  Actions as SavedLocationsActions,
} from "@app/store/savedLocations/actions";
import SavedLocationsUiState from "@app/store/savedLocationsUi/SavedLocationsUiState";

import {
  hideSavedLocationCard,
  hideSavedLocationNamingCard,
  SavedLocationsUiActions,
  showSavedLocationCard,
  showSavedLocationNamingCard,
} from "./actions";

export const savedLocationsUiInitialState: SavedLocationsUiState = {};

const savedLocationsUi = createReducer<
  SavedLocationsUiState,
  SavedLocationsActions | SavedLocationsUiActions
>(savedLocationsUiInitialState)
  .handleAction(showSavedLocationCard, (state, { payload: { id } }) => ({
    ...state,
    card: { id },
  }))
  .handleAction(hideSavedLocationCard, (state) => ({ ...state, card: undefined }))
  .handleAction(showSavedLocationNamingCard, (state, { payload }) => ({
    ...state,
    namingCard: payload,
  }))
  .handleAction(hideSavedLocationNamingCard, (state, { payload }) => {
    const { namingCard } = state;
    if (payload && !(namingCard?.kind === "naming" && namingCard.id === payload.id)) {
      return state;
    }
    return { ...state, namingCard: undefined };
  })
  .handleAction(resetSavedAddresses, () => savedLocationsUiInitialState);

export default savedLocationsUi;
